import React, { useEffect, useState } from "react";
import Credits from "./components/Credits";
import Logo from "./components/Logo";
import "./Login.sass";
import Div100vh from "react-div-100vh";
import { useHistory } from "react-router-dom";
import loginImg from "../../img/login_mes.png";

const LoginCommon = () => {

  const history = useHistory();

  const onLogin = async (userType) => {
    if(userType==="student"){
      history.push( "/login-otp");
    }else if(userType==="teacher"){
      history.push( "/login/teacher");
    }
  }

  return (
    <Div100vh>
      <div className="login uk-cover-container uk-flex uk-flex-center uk-flex-middle uk-overflow-hidden uk-light">
        {/* <div className="uk-position-cover" /> */}
        <div className="login-scrollable uk-flex uk-flex-center uk-flex-middle uk-position-z-index">
          <Credits />
          <div className="login_message" >
            <img src={loginImg} />
          </div>
          <div
            className="login-inner uk-width-medium uk-padding-small"
            data-uk-scrollspy="cls: uk-animation-fade"
          >
            <Logo />
            <div className="toggle-credits">
                  <div className="uk-margin-bottom">
                    <button
                      type="submit"
                      onClick = {e=> onLogin("student")}
                      className="uk-button uk-button-primary uk-border-pill uk-width-1-1"
                    >
                      LOG IN AS STUDENT
                    </button>
                  </div>
                  <div className="uk-margin-bottom">
                    <button
                      type="submit"
                      onClick = {e=> onLogin("teacher")}
                      className="uk-button uk-button-primary uk-border-pill uk-width-1-1"
                    >
                      LOG IN AS TEACHER
                    </button>
                  </div>
              <div>
                <div className="uk-text-center">
                  
                  <a
                    className="uk-link-reset uk-text-small toggle-class"
                    data-uk-toggle="target: .toggle-class ;animation: uk-animation-fade"
                    hidden
                  >
                    <span data-uk-icon="arrow-left" /> Back to Login
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Div100vh>
  );
};

export default LoginCommon;
